import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { KatalogAufloesungResponse } from '@/types/bestellung';

// Wie useVlbLookup: eine Auflösung wird ausgelöst (Enter oder Knopf),
// nicht abonniert. Anders als dort gibt es KEINE Automatik beim Tippen —
// "120-0" und "120-04" sind unterwegs zu "120-042" selbst gültige
// Nummern, eine Automatik löste also mitten im Tippen die falsche auf.
// Der ISBN fehlt diese Mehrdeutigkeit: sie ist erst mit gültiger
// Prüfziffer vollständig (A17).
export function useKatalogAufloesung() {
  return useMutation({
    mutationFn: (nummer: string) =>
      apiFetch<KatalogAufloesungResponse>(
        `/katalog/aufloesen.php?nr=${encodeURIComponent(nummer)}`
      )
  });
}
